<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 72.43 55.638"
  >
    <path
      id="Path_644"
      data-name="Path 644"
      d="M1667.293,1127.957a.817.817,0,0,1,.68-1.2c4.824-.215,9.368.355,13.576,2.781a16.586,16.586,0,0,1,7.768,8.768,48.6,48.6,0,0,1,1.252,5.225,23.341,23.341,0,0,1,2.15,1.557,10.429,10.429,0,0,1,1.965,2.157c.944,1.487.361,2.425-1.4,2.426-8.9,0-17.794.07-26.689-.042a8.19,8.19,0,0,0-3.807.756,7.453,7.453,0,0,0-2.386,1.9c-3.693,4.263-16.23,16.989-17.921,15.878a1.226,1.226,0,0,1-.4-.5c-.277-.643.113-1.4.278-2.061,1.466-5.862,2.97-11.714,4.467-17.568l0-.009a1.4,1.4,0,0,1,1.281-1.057q.149-.008.3-.009c2.322-.008,4.645,0,6.967-.008a2.127,2.127,0,0,0,1.055-.1c.4-.258.9-.678.932-1.067a1.731,1.731,0,0,0-.735-1.2,2.194,2.194,0,0,0-1.222-.2c-4.35-.012-8.7,0-13.05-.017a5.2,5.2,0,0,1-1.54-.211,2.515,2.515,0,0,1-1.8-2.429,2.626,2.626,0,0,1,2.1-2.3,8.21,8.21,0,0,1,1.561-.12c2.813-.011,5.626-.005,8.439-.006.294,0,.589.009.883-.01,1-.062,1.662-.613,1.632-1.339s-.723-1.225-1.727-1.226c-5.3-.007-10.6.005-15.9-.016a6.406,6.406,0,0,1-1.925-.27,2.585,2.585,0,0,1-1.783-2.455,2.552,2.552,0,0,1,1.8-2.348,5.351,5.351,0,0,1,1.728-.264c3.794-.022,7.588-.01,11.382-.013a4.3,4.3,0,0,0,.977-.042c.659-.156,1.249-.582,1.092-1.269a2.282,2.282,0,0,0-1.09-1.166,2.689,2.689,0,0,0-1.252-.1q-9.272-.007-18.545-.008a11.991,11.991,0,0,1-1.857-.11,2.889,2.889,0,0,1-2.459-2.563,2.829,2.829,0,0,1,2.21-2.767,6.383,6.383,0,0,1,1.551-.181c8.013-.011,16.027-.026,24.041,0,6.807.021,12.164,3.638,14.3,9.619a13.974,13.974,0,0,1,.635,7.338c-.026.14-.044.282-.06.422a.555.555,0,0,0,.552.632c.364-.02.518-.424.659-.771a14.028,14.028,0,0,0-.177-11.422C1667.645,1128.633,1667.476,1128.3,1667.293,1127.957Zm-36.563,16.413c.654,0,1.309.022,1.962,0a2.718,2.718,0,0,0,2.745-2.431,2.569,2.569,0,0,0-2.553-2.586,35.684,35.684,0,0,0-4.214.005,2.516,2.516,0,0,0-2.527,2.487,2.612,2.612,0,0,0,2.626,2.52c.652.04,1.307.007,1.962.007Zm-5.3-7.664a2.741,2.741,0,0,0,2.588-2.673,2.659,2.659,0,1,0-2.588,2.673Zm31.349,24.414-8.906,7.553a.888.888,0,0,0,.321,1.528l33.717,8.3a7.262,7.262,0,0,0,8.453-3.663s2.248-4.371,4.076-7.9a4.486,4.486,0,0,0-2.356-6.238l-1.927-.759a2.012,2.012,0,0,0-2.456.826l-1.087,1.786a4.086,4.086,0,0,1-4.847,1.73l-18.347-4.772A6.269,6.269,0,0,0,1656.783,1161.12Z"
      transform="translate(-1622.703 -1123.141)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
